import React, { useContext } from 'react';
import { MessageType, TranslateType } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';
import BaseTabs, { TabBase, TabsBase } from './tabsBase';

export type Tab = TabBase & {
  label?: MessageType;
};

const translateTab = (tab: Tab, translate: TranslateType) =>
  ({
    ...tab,
    label: tab.label ? translate(tab.label) : undefined,
  } as TabBase);

export type TabsProps = TabsBase<Tab>;
const Tabs: React.FC<TabsProps> = (props) => {
  const { translate } = useContext(LocaleCtx);
  const tabs: TabBase[] = props.tabs.map((t) =>
    translateTab(t, translate)
  );
  return <BaseTabs {...{ ...props, tabs }} />;
};

export default Tabs;
